export default __webpack_public_path__ + "static/media/project1-DJI_0872-2.2a91751e.jpg";